import { Route, Redirect } from 'react-router-dom';
import React, { useEffect } from 'react';
import { getCookie, setCookieHelper } from '../ultils/cookie'
import { userService } from '../services/users.services'
import { portfolioUsersService } from '../services/portfolioUsers.services.ts'
import { dataService } from '../services/data.services.ts'
import { tickersService } from '../services/tickers.services.ts'
import { EXPIRED_SECOND } from '../constants/Cookie'

export const RouteWrapper = ({ component: Component, layout: Layout, ...rest }) => {
  return (
    <Route
    {...rest}
    render={(props) => {
      return (
        <Layout {...props}>
          <Component {...props} />
        </Layout>
      )
    }}
  />
  )
}

export const ProtectedRouteWrapper = ({
    component: Component,
    layout: Layout,
    ...rest
}) => {

  return (
    <Route
      {...rest}
      render={(props) => {
        if (getCookie('accessToken')) {
          return (
            <Layout {...props}>
              <Component {...props} />
            </Layout>
          )
        } else {
          const originPath = window.location.pathname.split('/')[2]
              ? "company/" + window.location.pathname.split('/')[2]
              : '/'
          setCookieHelper('originPath', originPath, EXPIRED_SECOND)
          return <Redirect to={{ pathname: "/login", state: { from: props.location } }} />
        }
      }}
    />
  )
}

export const MoveBackHomeAfterLoggedInRouteWrapper = ({
    component: Component,
    layout: Layout,
    ...rest
}) => {
  return (
  <Route
    {...rest}
    render={(props) => {
      if (getCookie('accessToken')) {
        return <Redirect to={{ pathname: "/", state: { from: props.location } }} />
      } else {
        return (
          <Layout {...props}>
            <Component {...props} />
          </Layout>
        )
      }
    }}
  />
)
}
